var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLittleClock({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4324_37037)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.57064 3.25142V6.00142L7.40397 6.91809M10.154 6.00142C10.154 8.53273 8.10194 10.5848 5.57064 10.5848C3.03933 10.5848 0.987305 8.53273 0.987305 6.00142C0.987305 3.47012 3.03933 1.41809 5.57064 1.41809C8.10194 1.41809 10.154 3.47012 10.154 6.00142Z",
    stroke: "#B8BBC3",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4324_37037"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 11,
    height: 11,
    fill: "white",
    transform: "translate(0.0703125 0.501465)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLittleClock);
export default __webpack_public_path__ + "static/media/littleClock.3b64c66f907c6038a47ac163bfa2079f.svg";
export { ForwardRef as ReactComponent };